import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/pt-br/about")({
  head: () => ({
    meta: [
      { title: "Sobre o Picamini.online — Ferramentas Gratuitas e Privadas" },
      {
        name: "description",
        content: "Saiba mais sobre a missão do Picamini.online em oferecer ferramentas de sorteios, roletas e utilitários PDF 100% gratuitos no navegador.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/pt-br/sobre-o-picamini" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/about" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/sobre-nosotros" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/ueber-uns" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/sobre-o-picamini" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/about" },
    ],
  }),
  component: PtBrAboutPage,
});

function PtBrAboutPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="pt-BR" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">Sobre o Picamini.online</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          O <strong>Picamini.online</strong> é uma plataforma independente dedicada a fornecer ferramentas interativas de sorteios, roletas aleatórias e utilitários PDF 100% gratuitos, rápidos e focados em privacidade.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">Nossa Missão</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Acreditamos que professores, estudantes e organizadores de eventos não deveriam ter que pagar assinaturas carzinhas ou criar contas complexas apenas para sortear um nome, girar uma roleta ou juntar dois arquivos PDF. Todas as nossas ferramentas funcionam direto no navegador, sem upload de arquivos nem armazenamento de dados pessoais.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">Privacidade em Primeiro Lugar</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Nossa suíte PDF Toolkit Pro executa todas as edições e conversões de arquivos utilizando tecnologia WebAssembly e JavaScript no próprio dispositivo do usuário. Seus documentos nunca deixam seu computador ou celular.
        </p>
      </main>

      <SiteFooter lang="pt-BR" />
    </div>
  );
}
